// Creators list — persisted in localStorage
// VERSION 2 — vrais noms influenceurs PhotoRoom (sans espaces)
const LS_KEY = 'timbo_creators_v2';

const DEFAULT_CREATORS = [
  // AMBASSADORS / MX
  'Alejandra',
  'Alejandra Hernandez',
  'Andrea',
  'Danna',
  'Iveth',
  'Marinick',
  // AMBASSADORS / UK
  'Elise Constanty',
  'EdenNwaojigba',
  'EvaKashat',
  'MartaLiachovič',
  'SofiaHarrison',
  'UpperNostril',
  'WillReis',
  // AMBASSADORS / US
  'AngeleneSusanna',
  'AubreyMueller',
  'BrigitteComeau',
  'CadelJenkins',
  'DevonJenkins',
  'GoodlifecookinBrianChoi',
  'IsabellaLangford',
  'JamesSchneider',
  'JenniferMartin',
  'JennilynBravo',
  'JessKay',
  'KelseyMolnar',
  'LeonTaylor',
  'LorenaJusino',
  'LukeBittler',
  'MarcWarren',
  'MaureenJenkins',
  'MelDunn',
  'MitchelSchrader',
  'ReeceMartinez',
  'Riri',
  'RockwellResell',
  'SippyWyatt',
  'Tati',
  // CREATORS / MX
  'Cuvi',
  'Franniro',
  'JimenaSalinas',
  // CREATORS / Old School
  'FarahBrightart',
  'MaoMitra',
  'Nasion',
  'SofiaOfficial',
  'Spk',
  'ZRodrix',
];

// Canonical creator identity — the ONE place that decides equality across the scan result,
// the dropdown values and this whitelist. Strip accents + case + every non-alphanumeric, so
// "Cadel Jenkins" (Drive folder) == "CadelJenkins" (whitelist) == "cadel-jenkins" (filename).
export function canonKey(s) {
  return (s || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')  // strip accents
    .toLowerCase().replace(/[^a-z0-9]/g, '');           // strip case + separators
}

// Map a raw creator (folder name / filename hit / dropdown value) to a canonical display name:
// the whitelist entry if one shares its canonKey, otherwise the trimmed raw name. Returns ''
// when it cannot be resolved (empty / "unknown") — callers must treat '' as "not resolved".
export function canonicalCreator(raw, list) {
  if (!raw || String(raw).trim().toLowerCase() === 'unknown') return '';
  const key = canonKey(raw);
  if (!key) return '';
  const arr = list || getCreators();
  for (let i = 0; i < arr.length; i++) if (canonKey(arr[i]) === key) return arr[i];
  return String(raw).trim();
}

export function getCreators() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS_KEY));
    return saved && saved.length ? saved : [...DEFAULT_CREATORS];
  } catch { return [...DEFAULT_CREATORS]; }
}

export function saveCreators(list) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch {}
}

export function resetCreators() {
  try { localStorage.removeItem(LS_KEY); } catch {}
}

export default DEFAULT_CREATORS;
